import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const mapsIcon: SvgIconData = {
  viewBox: '89 59 156 215',
  element: (
    <path d="M89 137c0 35 67 137 80 137 14 0 76-103 76-137 0-43-35-78-78-78s-78 35-78 78m78 29c-16 0-29-13-29-29 0-15 13-28 29-28 15 0 28 12 28 27 1 16-12 30-28 30" />
  ),
};
